module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.validated) ? _c('div', [_c('app-header'), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.isAdmin) ? _c('router-view') : (_vm.clientReady) ? _c('router-view', {
    attrs: {
      "name": "client"
    }
  }) : _vm._e()], 1)], 1) : (_vm.agreement) ? _c('agreement') : (_vm.setpwd) ? _c('setpassword') : (_vm.invoice) ? _c('invoice') : (_vm.receipt) ? _c('receipt') : _c('login')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbd5cd42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 522
// module chunks = 1